import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

const InternalLink = ({ to, text }) => {
  return <Link to={to}>{text}</Link>
}

InternalLink.propTypes = {
  to: PropTypes.string,
  text: PropTypes.string,
}

export default InternalLink
